module.exports = __webpack_public_path__ + "static/media/portrait6.4420c8bd.jpg";